export const COMMUNICATION_INTERFACE = 'communicationInterface';
export const ACTUATOR = 'actuator';
export const VALVE = 'valve';
export const MANUFACTURER = 'manufacturer';
export const ALGO_PARAMETERS = 'algoParameters';
export const REGION = 'region';
export const ACTUATORS_LABEL = 'Actuators';
export const VALVES_LABEL = 'Valves';
export const MANUFACTURERS_LABEL = 'Manufacturers';
export const ALGO_PARAMETERS_LABEL = 'Algo Parameters';
export const REGIONS_LABEL = 'Regions';
export const ACTUATOR_VALVE_COMPATIBILITY_LABEL = 'Actuator-Valve Compatibility'
export const PREDEFINED_INSTALLATIONS_LABEL = 'Predefined Installations'
export const SUPPLY_METER = 'supplyMeter';
export const SUPPLY_VALVE = 'supplyValve';
export const RETURN_METER = 'returnMeter';
export const RETURN_VALVE = 'returnValve';
export const SELECTED_TAB = 'selectedTab';
export const ELECTRICAL_INTERFACE_TYPE = 'electricalInterfaceType';
export const COMPATIBLE_CONTROL_UNIT_TYPES = 'compatibleControlUnitTypes';
